import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { LocationIcon, MicrophoneIcon } from 'Asset/icon';
import { TextBold, TextRegular } from 'UiKit/typography';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const CardRequestInfo = ({ data }) => {
  const { t } = useTranslation('host-help-partner');
  const roomName = `${data?.studioRoom} | ${data?.studioName}`;
  const hostName = data?.hostName;
  const notes = data?.notes;

  return (
    <Box className={styles['card-request-info__container']}>
      <Flex gap={'12px'}>
        <MicrophoneIcon size="16px" color="var(--color-neutral60)" />
        <Flex flexDirection={'column'} gap={'4px'}>
          <TextRegular>{t('card.host')}</TextRegular>
          <TextBold>{hostName}</TextBold>
        </Flex>
      </Flex>

      <Flex gap={'12px'}>
        <LocationIcon size="16px" color="var(--color-neutral60)" />
        <Flex flexDirection={'column'} gap={'4px'}>
          <TextRegular>{t('card.room')}</TextRegular>
          <TextBold>{roomName}</TextBold>
        </Flex>
      </Flex>

      <Condition statement={notes}>
        <Flex gap={'4px'} flexDirection={'column'} className={styles['notes__container']}>
          <TextRegular>{t('card.notes')}</TextRegular>
          <TextBold>{notes}</TextBold>
        </Flex>
      </Condition>
    </Box>
  );
};

export default CardRequestInfo;
